<template>
  <div id="app">
    <div class="wrapper">
      <div class="container">
        <!-- red header -->
        <div class="header">
          <img class="roadhk-icon"
               src="./assets/iconver1_blackwhite.png"
          />

          <img
            class="map-icon"
            src="./assets/mapicon.png"
            @click="toggleMap()"
          />
        </div>
        <!-- content with left info bar and right map pane -->
        <div
          :class="{'map-shown': isMapShown}"
          class="content"
        >
          <div class="left-col">
            <div class="left-top-nav">
              <SearchMode/>
            </div>
            <div class="left-col-content-wrapper">
              <div class="left-col-content">
                <router-view></router-view>

                <!-- left column bottom -->
                <div class="left-column-bottom">Grumbleless Technology Limited</div>
              </div>
            </div>
          </div>
          <div class="right-col">
            <Map
              ref="gmap"
              :center="defaultLocation"
              :zoom="defaultZoom"
              map-type-id="roadmap"
              style="width: 100%; height: 100%"
            >
              <GmapMarker
                v-for="(m, index) in markers"
                :key="index"
                :clickable="true"
                :draggable="false"
                :icon="m.markerIcon"
                :position="m.position"
                @click="openInfoWindow(m)"
              >
                <gmap-info-window
                  :opened="m.infoWindowOpened"
                  :options="{content: `${m.routec} ${m.stopc} 往 ${m.routedir === 1 ? m.destinc : m.startc}`}"
                  @closeclick="infoWinOpen=false"
                >
                </gmap-info-window>
              </GmapMarker>

              <gmap-polyline
                v-for="(line, index) in mapLines"
                :key="`line-${index}`"
                :options="{strokeColor: line.color}"
                :path="line.line"
              >
              </gmap-polyline>
            </Map>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import router from './router/router.index'
import SearchMode from './components/Header/SearchMode';
import {Map} from 'vue2-google-maps';
import MapConstants from './config/enum/mapMarkers';
import locationPromise from "./config/location/locationPromise";
import {mapGetters, mapMutations, mapState} from "vuex";


export default {
  name: 'App',
  router,
  props: ['gmap'],
  data() {
    return {
      isMapShown: true,
    };
  },
  computed: {
    ...mapState('nearbyRoutes', ['locationSet', 'userLocation']),
    ...mapState('googleMap', ['markers', 'mapBound', 'mapLines']),
    ...mapGetters('googleMap', ['getMarkersLatLngList']),
    defaultLocation() {
      return MapConstants.default.coord;
    },
    defaultZoom() {
      return MapConstants.default.zoom;
    },
  },
  methods: {
    ...mapMutations('nearbyRoutes', ['setUserLocation']),
    ...mapMutations('googleMap', ['openInfoWindow']),
    toggleMap() {
      console.log('changing map status', this.isMapShown);

      this.isMapShown = !this.isMapShown;
    },
  },
  components: {SearchMode, Map},
  watch: {
    /*
    markers(markers){
        this.$refs.gmap.$mapPromise
            .then(map => {
                const latlngList = markers.map(x => x.position);

                const bounds = new google.maps.LatLngBounds();
                latlngList.map(x => {
                    bounds.extend(x);
                });

                map.fitBounds(bounds);
            });
    },
    */

    mapBound(mapBound) {
      this.$refs.gmap.$mapPromise
        .then(map => {
          const bounds = new google.maps.LatLngBounds();

          mapBound.map(x => bounds.extend(x));
          map.fitBounds(bounds);

          const zoom = map.getZoom();
          map.setZoom(zoom > MapConstants.default.pointZoom ? MapConstants.default.pointZoom : zoom);
        });
    },
  },
  mounted() {
    const setUserLocation = this.setUserLocation;

    locationPromise()
      .then(location => setUserLocation(location));
  },

}
</script>

<style>
div.content.map-shown {
  position: relative;
  left: 0;
}
</style>

